/* --------------------------------------------------------------
 * Original bs-pdp behaviour: remember laser-cutting choice on submit
 * (null-guarded so it can never break the page).
 * -------------------------------------------------------------- */
(() => {
    const form = document.querySelector('.shopify-product-form');
    const lasercuttingCheckbox = document.querySelector('#questlog-laser-cutting');
    if (!form) return;
    form.addEventListener('submit', () => {
        if (lasercuttingCheckbox && lasercuttingCheckbox.checked) {
            localStorage.setItem('addLaserCuttingProduct', 'true');
        } else {
            localStorage.setItem('addLaserCuttingProduct', 'false');
        }
    });
})();

/* --------------------------------------------------------------
 * Questlog PDP --- desktop sticky two-column layout
 *
 * Desktop (>= 769px):
 *   LEFT  = configurator iframe (top, height-capped so the gallery
 *           stays above the fold) + product gallery below it;
 *           pinned in view while the right side scrolls.
 *   RIGHT = title, subtitle, price, configurator pricing, ATC
 *           (existing order kept), then the icon list, then the
 *           accordion.
 * Mobile (<= 768px): everything stacks; no sticky.
 *
 * MOBILE OVERSIZE FIX (see the two "QL FIX" comments in the mobile
 * media block below): on phones the configurator box was sometimes
 * rendered far too wide. Two independent causes:
 *   1) the off-canvas ajax-cart drawer is wider than the screen and
 *      inflated the mobile layout viewport (innerWidth jumped to
 *      ~679 on a ~448 device), so the configurator read a too-wide
 *      width; and
 *   2) the configurator column/iframe carry a fixed ~648px width.
 * Both are neutralised on mobile below.
 *
 * NOTE: the gallery tile sizing rules must NOT hit the lightbox
 * ([data-lightbox]/[data-lightbox-content]) --- the lightbox is
 * portaled to <body> by product-media-gallery.liquid on open, and
 * the selectors below are additionally scoped to [data-lightbox-item].
 * -------------------------------------------------------------- */
(() => {
    const CSS = [
        ':root{--ql-sticky-top:70px;--ql-gallery-height:120px;--ql-gallery-tile-mobile:84px;}',
        '@media screen and (min-width:769px){',
        '.ql-pdp-restructured{align-items:flex-start;}',
        '.ql-pdp-restructured .product__images{position:-webkit-sticky;position:sticky;top:var(--ql-sticky-top);align-self:flex-start;display:flex;flex-direction:column;gap:14px;max-height:calc(100vh - var(--ql-sticky-top) - 12px);}',
        '.ql-pdp-restructured .product__images .iframe_container{flex:0 0 auto;width:100%;height:min(580px,calc(100vh - var(--ql-sticky-top) - var(--ql-gallery-height) - 115px)) !important;}',
        '.ql-pdp-restructured .product__images .iframe_container iframe{height:100% !important;}',
        '.ql-pdp-restructured .ql-gallery-moved{flex:0 0 auto;min-height:0;width:100%;max-height:var(--ql-gallery-height);overflow:hidden;}',
        '.ql-pdp-restructured .ql-gallery-moved div:has(> img):not([data-lightbox-content]),.ql-pdp-restructured .ql-gallery-moved div:has(> video):not([data-lightbox-content]){flex:0 0 auto !important;width:var(--ql-gallery-height) !important;height:var(--ql-gallery-height) !important;min-width:var(--ql-gallery-height) !important;aspect-ratio:1 / 1 !important;overflow:hidden !important;}',
        '.ql-pdp-restructured .ql-gallery-moved [data-lightbox-item] img,.ql-pdp-restructured .ql-gallery-moved [data-lightbox-item] video{width:100% !important;height:100% !important;aspect-ratio:1 / 1 !important;object-fit:cover !important;}',
        '.ql-pdp-restructured .product__information{align-self:stretch;}',
        '.ql-pdp-restructured .product__information > .ql-moved-into-column{width:100%;max-width:100%;margin:22px 0 0;padding-top:0;padding-bottom:0;}',
        '.ql-pdp-restructured .product__information > .ql-moved-into-column .container,.ql-pdp-restructured .product__information > .ql-moved-into-column .page-width{max-width:100%;width:100%;padding-left:0;padding-right:0;}',
        '.ql-pdp-restructured .product__information .ql-icon-list{display:flex !important;flex-direction:column !important;gap:14px !important;}',
        '.ql-pdp-restructured .product__information .ql-icon-list__item{flex:1 1 100% !important;width:100% !important;max-width:100% !important;display:flex !important;flex-direction:row !important;align-items:flex-start !important;gap:12px !important;text-align:left !important;}',
        '.ql-pdp-restructured .product__information .ql-icon-list__icon{flex:0 0 auto !important;width:auto !important;margin:0 !important;}',
        '.ql-pdp-restructured .product__information .ql-icon-list__text{flex:1 1 auto !important;text-align:left !important;}',
        '.ql-pdp-restructured .product__information .ql-icon-list__title{margin:0 0 2px !important;font-size:0.95rem;line-height:1.2;text-align:left !important;}',
        '.ql-pdp-restructured .product__information .ql-icon-list p{margin:0;font-size:0.85rem;line-height:1.35;text-align:left !important;}',
        '}',
        '@media screen and (max-width:768px){',
        '/* QL FIX: on phones the configurator box was sometimes drawn far too wide. Two causes: (a) the off-canvas FIXED ajax-cart drawer (#theme-ajax-cart) can inflate the mobile layout viewport (window.innerWidth jumped to ~679 on a ~448 screen), and (b) the configurator column/iframe carry a fixed ~648px width. We clamp the configurator to the REAL device width via the --ql-dvw variable (set from documentElement.clientWidth in JS, which stays at the true ~448 even when the layout viewport inflates). This deliberately does NOT put overflow on html/body, because that breaks the fixed sticky ATC (#stickyATC). */',
        '.product__images,.product__images .iframe_container,#product-image-placeholder,#config{max-width:var(--ql-dvw,100vw) !important;}',
        '.product__images .iframe_container,#product-image-placeholder,#config{width:100% !important;}',
        '.ql-pdp-restructured .ql-gallery-moved{max-height:var(--ql-gallery-tile-mobile) !important;overflow-x:auto !important;overflow-y:hidden !important;-webkit-overflow-scrolling:touch;}',
        '.ql-pdp-restructured .ql-gallery-moved div:has(> img):not([data-lightbox-content]),.ql-pdp-restructured .ql-gallery-moved div:has(> video):not([data-lightbox-content]){flex:0 0 auto !important;width:var(--ql-gallery-tile-mobile) !important;height:var(--ql-gallery-tile-mobile) !important;min-width:var(--ql-gallery-tile-mobile) !important;aspect-ratio:1 / 1 !important;overflow:hidden !important;}',
        '.ql-pdp-restructured .ql-gallery-moved [data-lightbox-item] img,.ql-pdp-restructured .ql-gallery-moved [data-lightbox-item] video{width:100% !important;height:100% !important;aspect-ratio:1 / 1 !important;object-fit:cover !important;}',
        '}'
    ].join('');

    // Expose the REAL device (visual) width as --ql-dvw. documentElement.clientWidth
    // stays at the true screen width (~448) even when an off-canvas fixed element
    // inflates window.innerWidth, so the configurator clamp above is immune to it.
    function setDeviceWidthVar() {
        const w = document.documentElement.clientWidth;
        if (w > 0) document.documentElement.style.setProperty('--ql-dvw', w + 'px');
    }
    setDeviceWidthVar();

    function injectCSS() {
        setDeviceWidthVar();
        if (document.getElementById('ql-pdp-layout-css')) return;
        const s = document.createElement('style');
        s.id = 'ql-pdp-layout-css';
        s.textContent = CSS;
        document.head.appendChild(s);
    }

    function getGallery(section) {
        const form = section.querySelector('.shopify-product-form');
        if (form) {
            const g = Array.prototype.slice.call(form.children)
                .filter((c) => /ql-media-gallery/.test('' + c.className))[0];
            if (g) return g;
        }
        let any = section.querySelector('[class*=ql-media-gallery]');
        if (any) {
            while (any.parentElement && /ql-media-gallery/.test('' + any.parentElement.className)) {
                any = any.parentElement;
            }
        }
        return any;
    }

    function moveGallery(section, left) {
        const iframeC = left.querySelector('.iframe_container');
        if (!iframeC) return false;
        const gallery = getGallery(section);
        if (!gallery) return false;
        if (left.contains(gallery) && gallery.classList.contains('ql-gallery-moved')) return true;
        gallery.classList.add('ql-gallery-moved');
        iframeC.insertAdjacentElement('afterend', gallery);
        return true;
    }

    function moveExtraSections(right) {
        const iconSec = document.querySelector('.ql-icon-list-section');
        if (iconSec && !iconSec.classList.contains('ql-moved-into-column')) {
            iconSec.classList.add('ql-moved-into-column');
            right.appendChild(iconSec);
        }
        const accInner = document.querySelector('.ql-accordion-section');
        const accSec = accInner ? (accInner.closest('.shopify-section') || accInner) : null;
        if (accSec && !accSec.classList.contains('ql-moved-into-column')) {
            accSec.classList.add('ql-moved-into-column');
            right.appendChild(accSec);
        }
    }

    function setStickyOffset() {
        let offset = 20;
        const candidates = document.querySelectorAll('header, [class*=header]');
        for (let i = 0; i < candidates.length; i++) {
            const cs = window.getComputedStyle(candidates[i]);
            if (cs.position === 'fixed' || cs.position === 'sticky') {
                const h = Math.round(candidates[i].getBoundingClientRect().height);
                if (h > offset && h < 200) offset = h + 10;
            }
        }
        document.documentElement.style.setProperty('--ql-sticky-top', offset + 'px');
    }

    function init() {
        const section = document.querySelector('.product-main .product_section')
            || document.querySelector('.product_section');
        if (!section) return false;
        const left = section.querySelector('.product__images');
        const right = section.querySelector('.product__information');
        if (!left || !right) return false;
        injectCSS();
        section.classList.add('ql-pdp-restructured');
        setStickyOffset();
        const galleryDone = moveGallery(section, left);
        moveExtraSections(right);
        return galleryDone;
    }

    function boot() {
        init();
        let tries = 0;
        const iv = setInterval(() => {
            tries++;
            if (init() || tries > 25) clearInterval(iv);
        }, 300);
        window.addEventListener('resize', setStickyOffset);
        window.addEventListener('resize', setDeviceWidthVar);
        window.addEventListener('orientationchange', () => setTimeout(setDeviceWidthVar, 300));
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
